import React from 'react';
import {Checkbox, FormGroup} from 'react-bootstrap';

const CPSettingToggle = ({
    name,
    isChecked = false,
    label,
    hint = '',
    onChange,
}) => {
    return (
        <FormGroup>
            <Checkbox
                checked={isChecked}
                value={isChecked}
                name={name}
                onChange={(e) => onChange({[name]: e.target.checked})}
            >
                {label}
            </Checkbox>
            {
                !!hint &&
                <p>
                    <i>
                        ({hint})
                    </i>
                </p>
            }
        </FormGroup>
    )
}

export default CPSettingToggle;
